import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';

@Pipe({
  standalone: false,
  name: 'mxDateAgo',
  pure: true,
})
export class MxDateAgoPipe implements PipeTransform {
  transform(value: any): any {
    if (!value) {
      return value;
    }

    const seconds = Math.floor(
      (+new Date() -
        +moment(
          moment(value).utcOffset(0).format('YYYY-MM-DD HH:mm:ss'),
          'YYYY-MM-DD HH:mm:ss',
          true
        ).toDate()) /
        1000
    );

    if (seconds < 29) {
      return 'most';
    }

    const intervals: Record<string, number> = {
      eve: 31536000,
      honapja: 2592000,
      hete: 604800,
      napja: 86400,
      oraja: 3600,
      perce: 60,
      masodperce: 1,
    };

    for (const key of Object.keys(intervals)) {
      const counter = Math.floor(seconds / intervals[key]);
      if (counter > 0) {
        return `${counter} ${key}`;
      }
    }

    return value;
  }
}
